module.exports = __webpack_public_path__ + "static/media/bp-inner.0497c1b7.webp";